import type { CartItemBase } from 'core/domains';
import { useQueryState } from 'core/use-cases/utilities';

import {
  useUserBuyIntentionSelector,
  useUserSelector,
  useUserCreditSelector,
  useUserSearchInputSelector,
} from '../selectors';

export function useUser() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useUserSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

export function useUserCredit() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useUserCreditSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

export function useUserBuyIntention() {
  return useUserBuyIntentionSelector();
}

export const useIsBuyIntention = () => {
  const items = useUserBuyIntentionSelector();

  const isBuyIntention = (productCode: CartItemBase['productCode']) =>
    items.some((buyIntentionProductCode) => buyIntentionProductCode === productCode);

  return { isBuyIntention };
};

export function useUserSearchInput() {
  const searchInput = useUserSearchInputSelector();

  return searchInput;
}
